/**
 * Etiquetas de una tarea: prioridad, tipo y las dos marcas de atención
 * («toca riego» y «pide algo a producción») y el proyecto, si tiene (con un enlace a su repo cuando lo tiene).
 */
import { ETIQUETA_TIPO, type Tarea } from '@cdtec-backlog/contrato';
import { useEtiquetaPrioridad } from '../configuracion/hooks';
import { EnlaceRepo } from '../proyectos/EnlaceRepo';

type Datos = Pick<Tarea, 'prioridad' | 'tipo' | 'tocaRiego' | 'requiereProduccion' | 'proyecto'>;

interface Props {
  tarea: Datos;
  /** `false` donde el enlace al repo ya se muestra aparte (el detalle de la tarea). */
  conEnlaceRepo?: boolean;
  /** `false` en la tarjeta: ahí el tipo ya se ve en el ícono de la esquina. */
  conTipo?: boolean;
}

/** Chip de prioridad con punto de color. La clase usa el código técnico (P0..P3); el texto, el nombre configurado. */
export function EtiquetaPrioridad({ prioridad }: { prioridad: Tarea['prioridad'] }) {
  const etiquetaPrioridad = useEtiquetaPrioridad();
  return (
    <span className={`etiqueta etiqueta--punto etiqueta--${prioridad.toLowerCase()}`}>
      {etiquetaPrioridad(prioridad)}
    </span>
  );
}

export function EtiquetasTarea({ tarea, conEnlaceRepo = true, conTipo = true }: Props) {
  return (
    <div className="etiquetas">
      <EtiquetaPrioridad prioridad={tarea.prioridad} />
      {conTipo && <span className="etiqueta">{ETIQUETA_TIPO[tarea.tipo]}</span>}
      {tarea.proyecto && (
        <span className="etiquetas__proyecto">
          {/* El nombre largo se corta con «…» (ver .etiqueta--proyecto) y el title lo muestra completo. */}
          <span className="etiqueta etiqueta--proyecto" title={tarea.proyecto.nombre}>
            <span className="solo-lectores">Proyecto: </span>
            {tarea.proyecto.nombre}
          </span>
          {conEnlaceRepo && <EnlaceRepo proyecto={tarea.proyecto} />}
        </span>
      )}
      {tarea.tocaRiego && <span className="etiqueta etiqueta--riego">Toca riego</span>}
      {tarea.requiereProduccion && (
        <span className="etiqueta etiqueta--produccion">Pide algo de producción</span>
      )}
    </div>
  );
}
